import { z } from 'zod'

/** Identificador cuid2 gerado pelo Prisma. */
export const idSchema = z.string().min(1, 'Identificador obrigatorio')

export const slugSchema = z
  .string()
  .min(1, 'Slug obrigatorio')
  .max(96, 'Slug muito longo')
  .regex(/^[a-z0-9]+(?:-[a-z0-9]+)*$/, 'Use apenas letras minusculas, numeros e hifens')

export const paginationQuerySchema = z.object({
  page: z.coerce.number().int().min(1).default(1),
  perPage: z.coerce.number().int().min(1).max(100).default(20),
})

export type PaginationQuery = z.infer<typeof paginationQuerySchema>

export interface Paginated<T> {
  items: T[]
  page: number
  perPage: number
  total: number
  totalPages: number
}

/** Metadados de pagina servidos ao front e usados na injecao de meta tags. */
export const pageMetaSchema = z.object({
  title: z.string(),
  description: z.string(),
  image: z.string().nullable(),
  canonical: z.string(),
  type: z.enum(['website', 'article']),
  publishedTime: z.string().nullable(),
})

export type PageMeta = z.infer<typeof pageMetaSchema>

/** Resposta de erro padronizada de toda a API. */
export const apiErrorSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
    /** Erros por campo, quando a falha e de validacao. */
    fields: z.record(z.string(), z.array(z.string())).optional(),
  }),
})

export type ApiError = z.infer<typeof apiErrorSchema>
